import React from 'react';
import styled from 'styled-components';
import testimonial_background from 'assets/testimonials/testimonial_background.png';
import testimonial_background_mobile from 'assets/testimonials/testimonial_background_mobile.png';
import { BREAKPOINTS } from 'constants/common';

export const TestimonialWrapper = styled.div`
  background-color: var(--primary);
  border-radius: 10px;
  margin-top: 25px;
  margin-bottom: 25px;
  padding: 45px 42px 38px;
  background-image: url(${testimonial_background_mobile});
  background-size: cover;
  background-position: bottom;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (min-width: ${BREAKPOINTS.maxTablet}px) {
    min-height: 540px;
    width: 300px;
    margin-top: 13px;
    background-image: url(${testimonial_background});
  }

  @media (min-width: ${BREAKPOINTS.minDesktop}px) {
    min-height: 640px;
    width: 347px;
  }
`;

const Flex = styled.div`
  margin: auto;
`;

const TestimonialAuthorBio = styled.div`
  margin-right: 10px;
  margin-left: 10px;
`;

export const TestimonialText = styled.div`
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  text-align: center;
  color: var(--white);
  letter-spacing: 0.1px;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    font-size: 18px;
    line-height: 22px;
  }

  @media (min-width: ${BREAKPOINTS.maxTablet}px) {
    font-size: 24px;
    line-height: 30px;
  }
  @media (min-width: ${BREAKPOINTS.minDesktop}px) {
    font-size: 28px;
    line-height: 34px;
  }
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  margin-top: 21px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--white);
  letter-spacing: -0.4px;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    margin-top: 30px;
  }

  @media (min-width: ${BREAKPOINTS.maxTablet}px) {
    margin-top: 66px;
  }
`;

const TestimonialAuthorName = styled.div``;

export function Testimonial({
  className,
  testimonial: { name, text },
}: {
  className?: string;
  testimonial: {
    name: string;
    text: string;
    className?: string;
  };
}) {
  return (
    <TestimonialWrapper className={className}>
      <Flex>
        <TestimonialText>{text}</TestimonialText>
        <TestimonialAuthor>
          <TestimonialAuthorBio>
            <TestimonialAuthorName>{name}</TestimonialAuthorName>
          </TestimonialAuthorBio>
        </TestimonialAuthor>
      </Flex>
    </TestimonialWrapper>
  );
}
